import React, {useEffect, useState} from "react"
import PayGameStyle from "./PayGame.module.css"
import * as PaymentService from "../api/PaymentsService"
import cabinetStyle from "./mentorCabinet/MentorCabinet.module.css";
import {useEffectOnce} from "../hooks/useEffectOnce";
import {useTranslation} from "react-i18next";

export default function PayGame(props) {
    const { t,i18n } = useTranslation('translation', { keyPrefix: 'payGame' });
    const [currentBalance, setCurrentBalance] = useState()
    const [remainingPrice, setRemainingPrice] = useState()
    const [payButtonEnabled, setPayButtonEnabled] = useState(true)

    function payGame() {
        setPayButtonEnabled(false)
        PaymentService.payGame(
            props.gameId,
            ()=>{},
            ()=>{
                window.alert("Payment failed")
                setPayButtonEnabled(true)
            }
        )
    }


    useEffectOnce(() => PaymentService.getCurrentBalance(
        (jres) => {
            setCurrentBalance(jres.balance)
        },
        () => {
        }
    ))

    useEffectOnce(() => PaymentService.getGameRemainingPrice(
        props.gameId,
        (jres) => {
            setRemainingPrice(jres.remaining)
        },
        () => {
        }
    ))

    return <div className={PayGameStyle.container}>
        {props.createdInFreeTier && <div>{t('gameCreatedInFreePeriod')}</div>}
        <div>{t('continueAfterPay')} {props.isMentor ? "" : t('byHost')}</div>
        {props.isMentor && currentBalance !== undefined &&
            <div className={PayGameStyle.currentBalanceRow}>{t('currentBalance')} {currentBalance}
                <div className={cabinetStyle.coinSmall}/>
            </div>}
        {props.isMentor && remainingPrice !== undefined &&
            <div
                className={payButtonEnabled ? PayGameStyle.payButtonEnabled : PayGameStyle.payButtonDisabled}
                onClick={payButtonEnabled ? payGame : ()=>{}}
            >
                {t('pay')} {remainingPrice}
                <div className={cabinetStyle.coinSmall}/>
            </div>
        }
    </div>
}
